import { PriorityRequestResponse } from "@/api";
import { DataTable } from "@/common/components/table/DataTable";
import { PriorityRequestRowActions } from "@/pages/priority-requests/PriorityRequests.types";

import { usePriorityRequestsColumns } from "./hooks/usePriorityRequestsColumns";

const ROW_HEIGHT = 56;

interface Props {
  rows: PriorityRequestResponse[];
  isLoading: boolean;
  paginationResetKey: string;
  actions: PriorityRequestRowActions;
}

export function PriorityRequestsTable({ rows, isLoading, paginationResetKey, actions }: Props) {
  const columns = usePriorityRequestsColumns(actions);

  return (
    <DataTable
      data={rows}
      columns={columns}
      getRowId={(row) => row.clientId}
      isLoading={isLoading}
      rowHeight={ROW_HEIGHT}
      autoRowHeight
      initialSortModel={[{ field: "appointmentStartUtc", sort: "asc" }]}
      disableColumnMenu
      paginationResetKey={paginationResetKey}
    />
  );
}
